import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["currency", "networkRow", "network"]

  connect() {
    this.updateNetwork()
  }

  updateNetwork() {
    const currency = this.currencyTarget?.value
    if (!currency) {
      this.showNetwork()
      return
    }

    if (currency === "usdt") {
      this.showNetwork()
      return
    }

    this.hideNetwork()
  }

  showNetwork() {
    if (this.hasNetworkRowTarget) {
      this.networkRowTarget.hidden = false
    }
    if (this.hasNetworkTarget) {
      this.networkTarget.disabled = false
    }
  }

  hideNetwork() {
    if (this.hasNetworkRowTarget) {
      this.networkRowTarget.hidden = true
    }
    if (this.hasNetworkTarget) {
      this.networkTarget.disabled = true
    }
  }
}
